import Glide from '@glidejs/glide';

if ($('.js-post-slider-featured__slider').length) {
    new Glide('.js-post-slider-featured__slider', {
        type: 'carousel',
        perView: 3,
        gap: 30,

        breakpoints: {
            767: {
                perView: 2,
                gap: 15,
                peek: { before: 30, after: 30 }, // Adjust peek values for mobile
            },
            991: {
                perView: 3,
                focusAt: 'center', // Center at tablet breakpoint
                peek: { before: 50, after: 50 }, // Adjust peek values for mobile

            },
        },
    }).mount();
}